export default __webpack_public_path__ + "static/media/Tawah_Blamah_Flomo.b804c672.png";